module.exports = __webpack_public_path__ + "assets/certificate_pdf/ssa_112_19.bd7895f0.pdf";